import { formatFromJsonDate } from "../../../../dateConfig";
import LoadingSpinner from "../../../LoadingSpinner";
import Grid from "../../../Grid";
import React, { useEffect, useState } from "react";
import { getTimeRemovalLog } from "../../../../api/jobApi";
import { Info } from "react-feather";

const JobTimeRemovalLog = ({ jobId, active, Header }) => {
  const [timeRemovalLog, setTimeRemovalLog] = useState([]);
  const [showStatusDetails, setShowStatusDetails] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // Reload every time the tab is opened so removals done in Status Manager show up
  useEffect(() => {
    (async () => {
      if (active && jobId) {
        setIsLoading(true);
        const response = await getTimeRemovalLog(jobId);
        setTimeRemovalLog(
          response && response.length > 0
            ? response.map((log) => ({
                ...log,
                existingTimeFormated: log.existingTime
                  ? formatFromJsonDate(log.existingTime)
                  : "",
                timeRemovalTimeFormated: log.timeRemovalTime
                  ? formatFromJsonDate(log.timeRemovalTime)
                  : "",
              }))
            : [],
        );
        setIsLoading(false);
      }
    })();
  }, [jobId, active]);

  return (
    <>
      <h2>Time Removal Log</h2>
      <div className="ui segment">
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${showStatusDetails ? "active" : ""}`}
            onClick={() => setShowStatusDetails((prevState) => !prevState)}
          >
            <div>
              Job Information
              <Info size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${showStatusDetails ? "active" : ""}`}>
            <Header />
          </div>
        </div>

        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <Grid
              showDownloadButton={true}
              downloadOnlySelected={false}
              reportName="time_removal_log.csv"
              config={[
                {
                  headerName: "Request No.",
                  field: "reqCode",
                },
                {
                  headerName: "Job No.",
                  field: "jobCode",
                },
                {
                  headerName: "Location",
                  field: "locationName",
                  minWidth: 200,
                },
                {
                  headerName: "Location Time Change Type",
                  field: "locationTimeChangeType",
                  minWidth: 260,
                },
                {
                  headerName: "Location Type",
                  field: "locationType",
                },
                {
                  headerName: "Existing Time",
                  field: "existingTimeFormated",
                  minWidth: 220,
                },
                {
                  headerName: "Time Removal Time",
                  field: "timeRemovalTimeFormated",
                  minWidth: 220,
                },
                {
                  headerName: "Time Removed By",
                  field: "timeRemovedBy",
                },
              ]}
              content={timeRemovalLog}
            />
          )}
        </>
      </div>
    </>
  );
};

export default JobTimeRemovalLog;
